import { UserManagerSettings } from 'oidc-client';

export const environment = {
  production: true,
  env: 'staging',
  hmr: false,
  registryUrl: 'https://registry.staging.browsermodules.ihsmarkit.com',
  apiBaseUrl: 'https://api.staging.polaris.ihsmarkit.com',
  wsUrl: 'wss://gateway.staging.sockets.ipreo.com/connect',
  enableRouterTracing: false,
  instrumentStore: false,
  loadLocalDevModules: false,
  groupName: 'USG-Muni_SellSide_Users',
  splunkRumToken: 't5z3X2sv9z8RCu9sMaqvTg',
  splunkSessionReplayEnabled: true,
  oidcSettings: {
    authority:
      'https://sam.samexternal.net/sso/oauth2/realms/root/realms/Customers',
    client_id: 'GlobalMarkets-Polaris-Staging-tFIVdQYlUq',
    redirect_uri: 'https://staging.globalmarkets.ihsmarkit.com',
    post_logout_redirect_uri: 'https://staging.globalmarkets.ihsmarkit.com',
    response_type: 'code',
    scope: 'openid email profile saml_attributes northstar:write',
    automaticSilentRenew: true,
    silentRequestTimeout: 10000,
    filterProtocolClaims: true,
    loadUserInfo: true,
  } as UserManagerSettings,
};
